module.exports = __webpack_public_path__ + "assets/images/carSeat-02.61ab07c0c99f0d709e2b4b3189905736.svg";